import Http from "../api/http";

export default class SysArea extends Http {
  constructor() {
    super();
  }

  /***********省市区联动***************/
  /**
   * 省市区联动
   */
  sysArea_getSysAreaList() {
    return super.post("sysArea/getSysAreaList", ...arguments)
  }

  /**
 * 省市区联动
 */
  sysArea_getCountryCityList() {
    return super.post("sysArea/getCountryCityList", ...arguments)
  }
  
}